/* @flow */
import React, { Component } from "react";
import { connect } from "react-redux";

import Gettext, { withGettext } from "../common/Gettext";
import Popup, { Row, Button } from "../Popup";

import type { Dispatch } from "../../redux/action";
import type { State as ReduxState } from "../../redux/reducer";
import type { State as Settings } from "../../redux/reducer/settings";

type Props = Settings & {
  dispatch: Dispatch,
  onClose: () => void,
  mobile?: boolean
};

// Самодельные выпадающие меню не испускают настоящих
// нативных событий, поэтому мы сделаем своё событие.
type SyntaticChangeEvent = {
  target: {
    name: string,
    value: any
  }
};

type State = {
  indicator: Object,
  activeSelect: string
};

class IndicatorPopup extends Component<Props, State> {
  state = {
    indicator: this.props.initialState,
    errors: null,
    activeSelect: ""
  };

  getValidator = (field: String) => {
    if (!this.props.validation) return null;

    return this.props.validation[field];
  };

  handleChange = (event: SyntaticChangeEvent) => {
    const { name, value } = event.target;
    const filtered = parseInt(value, 10);

    this.setState({
      indicator: {
        ...this.state.indicator,
        [name]: isNaN(filtered) ? value : filtered
      },
      activeSelect: ""
    });
  };

  handleAsIsChange = (event: SyntaticChangeEvent) => {
    const { name, value } = event.target;

    let errors = this.state.errors || {};

    const validator = this.getValidator(name);
    if (validator && !validator(value)) {
      errors[name] = true;
    } else {
      delete errors[name];
    }

    this.setState({
      errors,
      indicator: {
        ...this.state.indicator,
        [name]: value
      },
      activeSelect: ""
    });
  };

  handleNumberChange = (event: SyntaticChangeEvent) => {
    const { name, value } = event.target;
    const filtered = /^\d*$/.test(value) ? value : this.state.indicator[name];

    let errors = this.state.errors || {};

    const validator = this.getValidator(name);
    if (validator && !validator(filtered)) {
      errors[name] = true;
    } else {
      delete errors[name];
    }

    this.setState({
      errors,
      indicator: {
        ...this.state.indicator,
        [name]: filtered
      },
      activeSelect: ""
    });
  };

  handleNestedChange = (key, name) => {
    return (event: SyntaticChangeEvent) => {
      const { value } = event.target;

      let errors = this.state.errors || {};

      const validator = this.getValidator(`${key}_${name}`);
      if (validator && !validator(value)) {
        errors[`${key}_${name}`] = true;
      } else {
        delete errors[`${key}_${name}`];
      }

      this.setState({
        errors,
        indicator: {
          ...this.state.indicator,
          [key]: {
            ...this.state.indicator[key],
            [name]: value
          }
        },
        activeSelect: ""
      });
    }
  };

  handleClick = (name: string) => {
    this.setState({
      activeSelect: name
    });
  };

  handleReset = () => {
    this.setState({
      errors: null,
      indicator: this.props.initialState,
      activeSelect: ""
    });
  };

  handleSubmit = () => {
    if (this.checkEmptyFields()) {
      return false;
    }

    if (this.checkErrors()) {
      return false;
    }

    this.props.onSubmit(this.state.indicator);
  };

  checkEmptyFields = () => {
    let errors = [];
    const state = this.state.indicator;

    Object.keys(this.state.indicator).forEach(key => {
      if (state[key] === "") {
        errors.push(key);
      }
    });

    return errors.length > 0;
  };

  checkErrors = () => {
    return Object.keys(this.state.errors || {}).length > 0;
  };

  render() {
    const { indicator, errors,activeSelect } = this.state;

    return (
      <Popup
        title={this.props.title}
        onClose={this.props.onClose}
        mobile={this.props.mobile}
        info={this.props.info}
      >
        {this.props.children({
          mobile: this.props.mobile,
          indicator,
          errors,
          activeSelect,
          handleClick: this.handleClick,
          handleChange: this.handleChange,
          handleAsIsChange: this.handleAsIsChange,
          handleNumberChange: this.handleNumberChange,
          handleNestedChange: this.handleNestedChange
        })}

        <Row>
          <Button onClick={this.props.onClose}>
            <Gettext>Cancel</Gettext>
          </Button>
          <Button onClick={this.handleReset}>
            <Gettext>Reset</Gettext>
          </Button>
          <Button onClick={this.handleSubmit} isSubmit disabled={Object.keys(this.state.errors || {}).length > 0}>
            <Gettext>Apply</Gettext>
          </Button>
        </Row>
      </Popup>
    );
  }
}

export default connect((state: ReduxState) => state.settings)(
  withGettext(IndicatorPopup)
);



// WEBPACK FOOTER //
// ./src/components/Toolbar/IndicatorPopup.js